import ScalarFormField_vue_vue_type_script_setup_true_lang_default from "./ScalarFormField.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarForm/ScalarFormField.vue
var ScalarFormField_default = ScalarFormField_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarFormField_default as default };

//# sourceMappingURL=ScalarFormField.vue.js.map